import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib-nightly';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const medicalMessagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    companyName: 'DC Shoes',
    company: 'DC Shoes',
    step: {
        personalInfo: {
            title: 'Medical Discount<br>Unlock this medical-only offer',
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must (1) be a medical professional currently licensed in the United States and (2) be a member of an eligible branch of the medical profession. Eligible branches are shown in the Status selector of this form.<br><br>DC Shoes uses SheerID, a trusted partner, to verify that you are a medical professional. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.',
        },
        success: {
            redirectUrl: 'http://www.dcshoes.com',
            redirectButtonText: 'Shop Now',
            subtitle: 'Here is your personal coupon code.<br>It is unique to you and can only be used once.',
            verificationOnly: 'SheerID handles verification only. Now that you\'ve been approved, please direct all questions about the promotion terms and/or code use to DC Shoes customer service.',
        },
        docUpload: {
            title: 'We need more information',
            subtitle: 'Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner.',
            howDoesVerifyingWorkDetails: `Document review is handled by SheerID, a trusted partner who specializes in verifying age.
            <br><br>
            Documents are used only for verifying your current age and will be permanently deleted after review is finalized. They will not be shared with DC Shoes`,
        },
        pending: {
            titleReview: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.<br><br>This process may take up to 24 hours.',
        },
    },
    infoShared: 'Information entered here will be used for verification purposes and shared with DC Shoes.',
    statusPlaceholder: 'Status *',
    organizationPlaceholder: 'Organization *',
    firstNamePlaceholder: 'First Name *',
    lastNamePlaceholder: 'Last Name *',
    postalCodePlaceholder: 'Postal Code *',
    emailAddressPlaceholder: 'Email Address *',
    dateTime: {
        month: 'Month *',
        day: 'Day *',
        year: 'Year *',
    },
    birthDate: 'Date of Birth',
    postalCode: 'Postal Code',
    emailAddress: 'Email Address',
};
